import { Resource } from "../types/resource";

/** Shape returned by the `quizzes:get` and `quizzes:listByChat` Convex queries. */
export interface QuizQuestion {
  id: string;
  text: string;
  choices: string[];
  correctIndex: number;
  explanation?: string;
}

export interface QuizAnswer {
  questionId: string;
  choiceIndex: number | null;
  revealed: boolean;
}

export interface QuizAttempt {
  _id: string;
  answers: QuizAnswer[];
  score?: number;
  total: number;
  submittedAt?: number;
}

export interface Quiz {
  _id: string;
  title: string;
  messageId?: string;
  createdAt: number;
  questions: QuizQuestion[];
  attempt: QuizAttempt | null;
}

/**
 * Quiz resources are pointers: `id` and `content` are the Convex quiz id and
 * TestView loads the quiz itself. Using the id as content keeps the
 * content-based dedupe in `handleCreateResource` from adding a quiz twice.
 */
export function quizToResource(quiz: Pick<Quiz, '_id' | 'title' | 'createdAt' | 'messageId'>, chatId: string): Resource {
  return {
    id: quiz._id,
    type: 'quiz',
    title: quiz.title,
    content: quiz._id,
    timestamp: new Date(quiz.createdAt).toISOString(),
    chatId,
    messageId: quiz.messageId,
  };
}

/** The stream's `quiz` event carries a JSON array holding the new quiz. */
export function quizResourceFromStreamEvent(payload: string, chatId: string): Resource | null {
  try {
    const [quiz] = JSON.parse(payload);
    if (!quiz?.id || typeof quiz.id !== 'string') return null;
    const createdAt = Date.parse(quiz.timestamp);
    return quizToResource(
      { _id: quiz.id, title: quiz.title || 'Quiz', createdAt: Number.isFinite(createdAt) ? createdAt : Date.now() },
      chatId
    );
  } catch {
    return null;
  }
}
